// lightweight visitor + location tracking via cookies (no external geo service)
export function setCookie(name, value, days = 180) {
  const d = new Date();
  d.setTime(d.getTime() + days * 864e5);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/;SameSite=Lax`;
}
export function getCookie(name) {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : "";
}

export function trackVisitor() {
  try {
    if (!getCookie("sawd_visitor")) {
      setCookie("sawd_visitor", "v-" + Math.random().toString(36).slice(2));
      setCookie("sawd_first_seen", new Date().toISOString());
    }
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const locale = navigator.language || "";
    setCookie("sawd_geo", `${tz} | ${locale}`);
  } catch { /* ignore */ }
}

export function getLocation() {
  return getCookie("sawd_geo") || (Intl.DateTimeFormat().resolvedOptions().timeZone || "");
}

export function isFirstTime() {
  return getCookie("sawd_returning") !== "1";
}
export function markReturning() {
  setCookie("sawd_returning", "1", 365);
}
